export interface PayoutWalletSnapshot {
  available_cents: number;
  currency?: string | null;
  per_campaign_breakdown: Array<{ campaign_name: string; earned_cents: number }>;
}

export interface PayoutBankForm {
  cpf: string;
  pixKey: string;
  bank: string;
  agency: string;
  account: string;
}

export interface RequestCpmPayoutInputShape {
  amount_cents: number;
  currency: string;
  bank_data: PayoutBankForm;
  breakdown: Array<{ campaign_name: string; earned_cents: number }>;
}

/**
 * Shape the RequestCpmPayoutInput for the requestCpmPayout mutation: the full
 * available balance, a snapshot of the saved bank data, and the per-campaign
 * breakdown reduced to positive earnings with only the fields the backend
 * stores (no __typename / campaign_id from the Apollo cache).
 */
export function buildPayoutRequestInput({
  wallet,
  form,
}: {
  wallet: PayoutWalletSnapshot;
  form: PayoutBankForm;
}): RequestCpmPayoutInputShape {
  return {
    amount_cents: wallet.available_cents,
    currency: wallet.currency ?? 'BRL',
    bank_data: {
      cpf: form.cpf,
      pixKey: form.pixKey,
      bank: form.bank,
      agency: form.agency,
      account: form.account,
    },
    breakdown: wallet.per_campaign_breakdown
      .filter((entry) => entry.earned_cents > 0)
      .map((entry) => ({
        campaign_name: entry.campaign_name,
        earned_cents: entry.earned_cents,
      })),
  };
}
